var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryTestAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1789_16811)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8748 11.3755H2.12476V1.62549C2.12476 1.55674 2.06851 1.50049 1.99976 1.50049H1.12476C1.05601 1.50049 0.999756 1.55674 0.999756 1.62549V12.3755C0.999756 12.4442 1.05601 12.5005 1.12476 12.5005H12.8748C12.9435 12.5005 12.9998 12.4442 12.9998 12.3755V11.5005C12.9998 11.4317 12.9435 11.3755 12.8748 11.3755ZM3.77788 8.96455C3.82632 9.01299 3.90444 9.01299 3.95444 8.96455L6.11538 6.81455L8.10913 8.8208C8.15757 8.86924 8.23726 8.86924 8.2857 8.8208L12.5888 4.51924C12.6373 4.4708 12.6373 4.39111 12.5888 4.34268L11.9701 3.72393C11.9466 3.70066 11.9149 3.68761 11.8818 3.68761C11.8487 3.68761 11.817 3.70066 11.7935 3.72393L8.19976 7.31611L6.20913 5.31299C6.18564 5.28973 6.15391 5.27668 6.12085 5.27668C6.08779 5.27668 6.05606 5.28973 6.03257 5.31299L3.16069 8.16768C3.13743 8.19117 3.12438 8.2229 3.12438 8.25596C3.12438 8.28902 3.13743 8.32075 3.16069 8.34424L3.77788 8.96455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1789_16811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryTestAnalytics);
export default __webpack_public_path__ + "static/media/history-test-analytics.67e021348b7b9981bcbfae7e6722905f.svg";
export { ForwardRef as ReactComponent };